import { z } from 'zod';
import { bytesToGb } from '../biz/formatBytesToGb';
import { parseDateFromBackend } from '../biz/parseDateFromBackend';
import { parseDateTimeFromBackend } from '../biz/parseDateTimeFromBackend';
import {
  getProxyTypeMetaByName,
  ProxyTypeMeta,
  ProxyTypeZodEnum,
} from '../biz/proxyType';
import { httpApi } from './basicHttpApi';

export const SubscriptionDtoZod = z.object({
  ID: z.number(),
  proxy_type: ProxyTypeZodEnum,
  tier_id: z.number(),
  started_at: z.string(),
  paid_until: z.string(),
  is_renewable: z.boolean(),
  amount_monthly: z.number(),
  traffic_monthly: z.number(),
});

export type HttpSubscriptionType = z.infer<typeof SubscriptionDtoZod>;
export type SubscriptionType = {
  id: number;
  tag_id: number;
  proxyType: ProxyTypeMeta;
  tierId: number;
  startedAtDateTime: Date;
  paid_until: Date;
  recurrent: boolean;
  trafficGb: number;
  traffic_monthly_bytes: number;
  subscriptionCostUsd: number;
};

export const fetchSubscriptionList = async (): Promise<
  SubscriptionType[] | undefined
> => {
  const resp = await httpApi('subscriptions/list', undefined, 'GET');

  if (!Array.isArray(resp)) {
    throw new Error('fetchSubscriptionList: resp is not an array');
  }

  const result = resp.flatMap((raw) => {
    const parsed = SubscriptionDtoZod.safeParse(raw);
    if (!parsed.success) {
      console.error('fetchSubscriptionList error', { parsed });
      return [];
    }
    return [
      {
        id: parsed.data.ID,
        proxyType: getProxyTypeMetaByName(parsed.data.proxy_type),
        tierId: parsed.data.tier_id,
        paid_until: parseDateFromBackend(parsed.data.paid_until)!,
        startedAtDateTime: parseDateTimeFromBackend(parsed.data.started_at),
        recurrent: parsed.data.is_renewable,
        trafficGb: bytesToGb(parsed.data.traffic_monthly),
        traffic_monthly_bytes: parsed.data.traffic_monthly,
        subscriptionCostUsd: parsed.data.amount_monthly,
      } as SubscriptionType,
    ];
  });
  return result;
};

/*
http://139.162.187.132:10082/v1/subscriptions/list
GET, возвращает все подписки пользователя
пример ответа:
[
    {
        "ID": 7,
        "proxy_type": "residential",
        "tier_id": 2,
        "started_at": "2024-08-08T17:08:00.913948Z",
        "paid_until": "2024-12-01T00:00:00Z",
        "is_renewable": true,
        "amount_monthly": 132.75,
        "traffic_monthly": 53687091200
    },
    {
        "ID": 8,
        "proxy_type": "residential",
        "tier_id": 2,
        "started_at": "2024-08-08T17:55:48.221504Z",
        "paid_until": "2024-12-01T00:00:00Z",
        "is_renewable": true,
        "amount_monthly": 132.75,
        "traffic_monthly": 53687091200
    }
] 
Трафик возвращается в байтах, надо переделать в гигабайты для отображения

*/
